module.exports = __webpack_public_path__ + "img/signoria.4b6100d5.png";